import GroupsIcon from '@/assets/groups.svg';
import UnitsIcon from '@/assets/units.svg';
import { urls } from '@/constants/urls';
import { NavItem } from '@/types/nav-item';

export const navItems: NavItem[] = [
  {
    title: 'Groups',
    to: urls.groups.base,
    Icon: GroupsIcon,
  },
  {
    title: 'Units',
    to: urls.units.base,
    Icon: UnitsIcon,
  },
];
